module.exports = __webpack_public_path__ + "static/deep-knowledge-346eec699f6cdd72b77599aecb60c389.jpg";